(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
 const button = event.target.closest('[data-montana-photo]');
 if (!button) return;
 const gallery = button.closest('[data-montana-gallery]');
 const main = gallery.querySelector('.montana-gallery__main');
 main.removeAttribute('srcset'); main.src = button.dataset.montanaPhoto; main.alt = button.getAttribute('aria-label');
 gallery.querySelectorAll('button').forEach(function(item) { item.setAttribute('aria-pressed', String(item === button)); });
});

  } catch(e) { console.error(e); }
})();
})();
